import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, envConfig } from "../config";

export interface EmailTemplate {
  _id: string;
  name: string;
  subject: string;
  html: string;
  category?: string;
  createdAt: string;
  updatedAt: string;
}

export type CreateEmailTemplateDto = Omit<EmailTemplate, "_id" | "createdAt" | "updatedAt">;

export const emailTemplatesApi = createApi({
  reducerPath: "emailTemplatesApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "email-templates",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: ["EmailTemplates"],
  endpoints: (builder) => ({
    getEmailTemplates: builder.query<EmailTemplate[], void>({
      query: () => `/`,
      providesTags: ["EmailTemplates"],
    }),
    createEmailTemplate: builder.mutation<EmailTemplate, CreateEmailTemplateDto>({
      query: (body) => ({ url: `/`, method: "POST", body }),
      invalidatesTags: ["EmailTemplates"],
    }),
    updateEmailTemplate: builder.mutation<EmailTemplate, { id: string; body: Partial<CreateEmailTemplateDto> }>({
      query: ({ id, body }) => ({ url: `/${id}`, method: "PATCH", body }),
      invalidatesTags: ["EmailTemplates"],
    }),
    deleteEmailTemplate: builder.mutation<void, string>({
      query: (id) => ({ url: `/${id}`, method: "DELETE" }),
      invalidatesTags: ["EmailTemplates"],
    }),
    seedDefaultTemplates: builder.mutation<{ created: number; skipped: number }, void>({
      query: () => ({ url: `/seed-defaults`, method: "POST" }),
      invalidatesTags: ["EmailTemplates"],
    }),
  }),
});

export const {
  useGetEmailTemplatesQuery,
  useCreateEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useDeleteEmailTemplateMutation,
  useSeedDefaultTemplatesMutation,
} = emailTemplatesApi;
